module.exports = __webpack_public_path__ + "media/images/icon-stats-offers-b6a715819c33ee2ded4d36b28e774a47.svg";